import { isEnabled as isEnabledFromConfigLib, loadToggles } from '@aura/config-lib';
import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import { AsyncData } from '../../../../types/async-data.types';
import { initialValue } from '../../../../utils/initial-value.util';
import { useConfig } from '../../config.hook';
import { Context, Props, Provider } from './toggles.types';

export const TogglesContext = createContext<Context | null>(null);

export const TogglesProvider: Provider = ({ onLoading, onError, children }: Props) => {
  const { getValueOrThrow } = useConfig();
  const [status, setStatus] = useState<AsyncData<Record<string, boolean>>>(initialValue);

  const isEnabled = useCallback(
    (key: string): boolean => {
      if (status.pending) {
        return false;
      }
      if (!status.pending && status.error) {
        return false;
      }
      const localConfig = localStorage.getItem(key);
      if (localConfig) {
        return localStorage.getItem(key) === 'true';
      }

      return isEnabledFromConfigLib(key);
    },
    [status],
  );

  useEffect(() => {
    const url = `${getValueOrThrow<string>('API_DEDICADA')}/v2/toggles`;
    if (status.pending) {
      loadToggles({
        url,
      })
        .then(() =>
          setStatus({
            pending: false,
            value: {},
            error: null,
          }),
        )
        .catch((err) => {
          localStorage.setItem('stacktraceToggles', err.stack);
          setStatus({
            pending: false,
            value: null,
            error: err,
          });
        });
    }
  }, [status, setStatus, getValueOrThrow]);

  const result = useMemo(() => ({ isEnabled }), [isEnabled]);

  if (status.pending) {
    return onLoading;
  }

  if (!status.pending && status.error) {
    console.error({ message: 'Erro ao carregar as feature flags' });

    return onError;
  }

  return <TogglesContext.Provider value={result}>{children}</TogglesContext.Provider>;
};
